// extracted by mini-css-extract-plugin
module.exports = {"title":"CheckoutSuccess_title__3XzV9","par":"CheckoutSuccess_par__1jtHj"};